export default __webpack_public_path__ + "static/wave21-mobile-0d6397ea83b390716865d1b7cdaaee6c.png";